import { Typography } from '@emburse/embark';
import { ReactElement, CSSProperties } from 'react';

type Props = {
  title: string;
  value?: string | null;
  children?: ReactElement | null;
  placeholder?: string;
};

const style = {
  overflowWrap: 'break-word'
} as CSSProperties;

const InfoBoxDataItem = ({ title, value, children, placeholder }: Props): ReactElement => {
  return (
    <>
      <Typography variant="subtitle1" style={style}>{title}:</Typography>
      {value && <Typography variant="body1" style={style}>{value}</Typography>}
      {children && <Typography variant="body1" style={style}>{children}</Typography>}
      {!(value || children) && <Typography variant="body1" color="textSecondary" style={style}>{placeholder || 'N/A'}</Typography>}
    </>
  );
};

export { InfoBoxDataItem };
